import { createFileRoute } from "@tanstack/react-router";
import { ModuleDetailPage } from "../../../components/system/ModuleDetailPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export type ModuleDetailSearch = {
  trainingId?: string;
  questionId?: string;
};

export const Route = createFileRoute("/system/certifications/$moduleId/")({
  beforeLoad: requireSuperAdmin(),
  validateSearch: (search: Record<string, unknown>): ModuleDetailSearch => ({
    trainingId: typeof search.trainingId === "string" ? search.trainingId : undefined,
    questionId: typeof search.questionId === "string" ? search.questionId : undefined,
  }),
  component: ModuleDetailRoute,
});

function ModuleDetailRoute() {
  const { moduleId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <ModuleDetailPage
      moduleId={moduleId}
      trainingId={search.trainingId}
      questionId={search.questionId}
    />
  );
}
